import { useCallback } from "react"
import { useUser } from "@/apis/bff"
import { useResetChatHistoryTo } from "@/modules/chats/hooks/useChatHistory"
import { getGreetingMessageForThread } from "@/modules/chats/lib/get-greeting-message-translations"
import { ChatThread } from "@/modules/chats/types/chat-thread"

export const useGreetingPrefill = (): ((selectedThread: ChatThread) => void) => {
  const user = useUser()
  const resetHistoryTo = useResetChatHistoryTo()

  return useCallback(
    (selectedThread: ChatThread) => {
      const greeting = getGreetingMessageForThread(selectedThread, user.givenName, user.familyName)
      resetHistoryTo([{ content: greeting, aiFeatures: ["GREETING"] }])
    },
    [user, resetHistoryTo],
  )
}
